var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_787)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_103_787)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_103_787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.04659L20.2767 4.28523L20.2858 23.8438L0.01875 23.9591L0 7.04659ZM20.267 26.0972L20.283 45.6727L0.0159091 42.8864L0.0147727 25.9659L20.267 26.0972ZM22.725 3.92386L49.6102 0V23.5949L22.725 23.8085V3.92386ZM49.617 26.2812L49.6102 49.7699L22.725 45.9756L22.6875 26.2369L49.617 26.2812Z",
    fill: "#00ADEF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_103_787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_103_787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.7eddc0289ab65d1641a85d2dd3397d9e.svg";
export { ForwardRef as ReactComponent };